<template>
	<b-container fluid>
		<b-row>
			<b-col>
				<h5 class="text-center">Upcoming Classes</h5>
			</b-col>
		</b-row>
		<b-row class="text-center">
			<b-col>
				<b-button-group size="sm">
					<b-button class="upcomingClassesLegend" variant="light">At LifeForce</b-button>
					<b-button class="upcomingClassesLegend" variant="info">Online</b-button>
				</b-button-group>
			</b-col>
		</b-row>
		<div v-if="status === 'loading'" class='text-center my-3'>
			<b-spinner></b-spinner>
		</div>
		<div v-else-if="status === 'error'" class='text-center my-3'>
			<b-icon icon='x' variant="danger"></b-icon>
		</div>
		<div v-else-if="classes.length && status === 'fetched'">
			<b-row v-for="(Class, index) in classes" :key="index" class="text-center my-3">
				<b-col>
					<b-button
						v-if="Class.online"
						variant="info"
						class="upcomingClass"
						size="sm"
					>{{ new Date(Class.date).toString(0, 16).substr(0, 16) + '@' + getTimeString(Class.time) + ' - ' + Class.title }}</b-button>
					<b-button
						v-else
						variant="light"
						class="upcomingClass"
						size="sm"
					>{{ new Date(Class.date).toString(0, 16).substr(0, 16) + '@' + getTimeString(Class.time) + ' with ' + Class.instructor }}</b-button>
				</b-col>
			</b-row>
		</div>
		<div v-else>
			<b-row class='text-center my-3'>
				<b-col>
					<b-button
						class="noUpcomingClasses"
						variant="secondary"
						size='sm'
					>You are currently not signed up for any future classes</b-button>
				</b-col>
			</b-row>
		</div>
	</b-container>
</template>

<script>
// 6 -> 06
function padWithZero(day) {
	if (day.length === 1) {
		return "0" + day
	} else {
		return day
	}
}

export default {
	name: "UpcomingClasses",
	data() {
		return {
			status: "loading",
			classes: [],
		}
	},
	methods: {
		getUpcomingClasses: function() {
			return new Promise((resolve, reject) => {
				fetch(this.$apiURL + "/getUpcomingClasses", {
					method: "POST",
					headers: new Headers({
						Authorization: this.$store.state.token,
						"Content-Type": "application/json",
					}),
					body: JSON.stringify({
						today: new Date().toISOString().substr(0, 10),
					}),
				}).then(res => {
					if (res.ok) {
						res.json().then(classes => {
							this.classes = classes
							this.status = "fetched"
							resolve()
						})
					} else {
						this.status = "error"
						reject()
					}
				})
			})
		},
		getTimeString: function(time) {
			try {
				if (parseInt(time.substr(0, 2)) === 12) {
					return "12:00PM"
				} else if (parseInt(time.substr(0, 2)) > 12) {
					// Get hour substring from full time string
					// convert to integer and deduct 12
					// pad with zero if necessary
					// append PM
					return (
						padWithZero((parseInt(time.substr(0, 2)) - 12).toString()) +
						time.substr(2, 3) +
						"PM"
					)
				} else {
					return time.substr(0, 5) + "AM"
				}
			} catch {
				return ""
			}
		},
	},
	async created() {
		await this.getUpcomingClasses()
	},
}
</script>

<style scoped>
.upcomingClassesLegend {
	pointer-events: none;
	display: inline-block;
	width: 120px;
	margin: 0 auto;
}

.upcomingClass, .noUpcomingClasses {
	pointer-events: none;
	width: 425px;
	font-size: 16px;
}
</style>
